import React from 'react';
import { Navigate } from 'react-router-dom';
import Spinner from '../components/bootstrap/Spinner';
import { useAccessControl } from '../contexts/AccessControlContext';

/**
 * ProtectedRoute
 * Guards protected pages by checking the globally-initialized auth state from
 * AccessControlContext. The AccessControlProvider performs a single server-side
 * validation on app startup, so this guard is a synchronous, zero-flash check.
 *
 * If the session expires mid-session, the axios 401 interceptor in helpers/axios.ts
 * handles the redirect globally, so no per-route API call is needed here.
 */
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, isInitializing } = useAccessControl();

  // Safety net: should not reach here while initializing (App.tsx blocks first),
  // but guard defensively in case of direct usage outside App context.
  if (isInitializing) return <Spinner />;

  if (!isAuthenticated) return <Navigate to='/auth-pages/login' replace />;

  return <>{children}</>;
};

export default ProtectedRoute;